// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    gsList: This.GoalSetting[];
    selectedGs: This.GoalSetting;
    gs: This.GoalSetting;
    viewMode: This.GoalSettingViewMode;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-GoalSettingsMine',
    templateUrl: './GoalSettingsMine.html',
    styleUrls: ['./GoalSettingsMine.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalSettingsMine extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.GoalSettingsMine';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_gsList = proxySignal<This.GoalSetting[]>(undefined as any);
    var_selectedGs = proxySignal<This.GoalSetting>(undefined as any);
    var_gs = proxySignal<This.GoalSetting>(undefined as any);
    var_viewMode = proxySignal<This.GoalSettingViewMode>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get gsList() { return component.var_gsList() },
                set gsList(value: This.GoalSetting[]) { component.var_gsList.set(value) },
                get selectedGs() { return component.var_selectedGs() },
                set selectedGs(value: This.GoalSetting) { component.var_selectedGs.set(value) },
                get gs() { return component.var_gs() },
                set gs(value: This.GoalSetting) { component.var_gs.set(value) },
                get viewMode() { return component.var_viewMode() },
                set viewMode(value: This.GoalSettingViewMode) { component.var_viewMode.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.gsList = (undefined)
            if (!isVariablesInitialized) this.screen.selectedGs = (undefined)
            if (!isVariablesInitialized) this.screen.gs = (undefined)
            if (!isVariablesInitialized) this.screen.viewMode = (This.GoalSettingViewMode.Employee)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_DropdownBlock_61_selectionChange_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let selection: any = $event?.value
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    const result = await This.GoalSettingUtil.loadById(selection.id, 'employee')
                    screen.gs = result.gs
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            const result = await This.GoalSettingUtil.getMyGoalSettingsList()
            screen.gsList = result.list
            screen.selectedGs = result.list[0]
            screen.gs = result.newest
        }
    }
}
